import { JwtAxios } from '@/packaging';

export const youtubeManualAPI = {
  // 현재 페이지 URL에 매칭되는 유튜브 매뉴얼 조회 (활성화된 모든 매뉴얼)
  async getByPageUrl(pageUrl) {
    const res = await JwtAxios.get('/YoutubeManual/GetYoutubeManualsByPageUrl', { page_url: pageUrl });
    return res;
  }
};
